window.chartGkvGpv = {
	data: {
		// Liqui
		beitraege_kv: [],
		beitraege_pv: [],
		// Sonstiges
		startdatum: 0,
		enddatum: 0,
	},

	showLoading() {
		if (this.chart) this.chart.showLoading()
	},

	hideLoading() {
		if (this.chart) this.chart.hideLoading()
	},

	init() {
		this.chart = new Highcharts.stockChart("chart_gkv_gpv", {
			chart: {
				events: {
					selection: function (event) {
						return zoomIn(chartGkvGpv, event)
					},
				},
			},

			xAxis: {
				ordinal: false,
				min: this.data.startdatum,
				max: this.data.enddatum,
				events: {
					afterSetExtremes: function (event) {
						const chart = event.target.chart,
							min = event.min,
							max = event.max

						updateDataGrouping(chart, min, max)
					},
				},
			},

			legend: {
				enabled: true,
			},

			series: this.seriesLiqui(),
		})

		// Wenn der Chart Zeitraum kleiner ist als die Monatsgrenze das DataGrouping deaktivieren
		updateDataGrouping(this.chart, this.data.startdatum, this.data.enddatum)
	},

	update() {
		if (!this.chart) return

		this.chart.showLoading()

		const seriesArrays = [this.seriesLiqui()]
		const alleSeries = [].concat(...seriesArrays)

		alleSeries.forEach((serie) => {
			const s = this.chart.get(serie.id)
			if (s) s.setData(serie.data, false)
		})

		// xAchse: Min und Max aktualisieren
		this.updateXAxisMinMax()

		this.chart.redraw({ duration: chartAnimationDuration })
		this.chart.hideLoading()
	},

	updateXAxisMinMax() {
		const seriesMaxValues = this.chart.series.map((serie) => (Array.isArray(serie.xData) ? serie.xData.slice(-1)[0] : undefined)),
			xAxisMaxValue = Math.max(this.data.enddatum, ...seriesMaxValues.filter((element) => element !== undefined))
		this.chart.xAxis[0].update({ min: this.data.startdatum, max: xAxisMaxValue })
	},

	seriesLiqui() {
		return [
			{
				name: "Krankenversicherung",
				id: "gkv_beitrag",
				legendName: "Krankenversicherung",
				type: "column",
				color: farbeBeitrag1,
				data: this.data.beitraege_kv,
			},
			{
				name: "Pflegeversicherung",
				id: "gpv_beitrag",
				legendName: "Pflegeversicherung",
				type: "column",
				color: farbeBeitrag2,
				data: this.data.beitraege_pv,
			},
		]
	},
}
